import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/page.tsx\",\"import\":\"Ultra\",\"arguments\":[{\"weight\":\"400\",\"subsets\":[\"latin\"]}],\"variableName\":\"ultra\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web-app/src/components/landing/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web-app/src/components/landing/menu-sheet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandingNavigationMenu"] */ "/vercel/path0/web-app/src/components/landing/navigation-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web-app/src/components/landing/pricing-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web-app/src/components/magicui/blur-in.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FadeText"] */ "/vercel/path0/web-app/src/components/magicui/fade-text.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web-app/src/components/magicui/hero-video-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/vercel/path0/web-app/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web-app/src/components/ui/blur-fade.tsx");
